import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './SpanButton.less';

const {
	'span-button': span_button_class,
	'red': red_class,
	'green': green_class,
	'blue': blue_class,
	'yellow': yellow_class,
	'purple': purple_class,
} = styles;

export const Colors = {
	RED: 'red',
	GREEN: 'green',
	BLUE: 'blue',
	YELLOW: 'yellow',
	PURPLE: 'purple',
};

export default class SpanButton extends Component {
	render() {
		const { color, className, children, ...props } = this.props;

		const isUI2 = window.shop_productgroup && window.shop_productgroup.ui_version === '2.0';

		const button_classes = isUI2 ? ['button', 'green'] : [span_button_class];

		if (className) {
			button_classes.push(className);
		}

		if (!isUI2 && color && styles[color]) {
			button_classes.push(styles[color]);
		}

		const ButtonTag = isUI2 ? 'button' : 'span';

		return (
			<ButtonTag className={button_classes.join(' ')} {...props}>
				{children}
			</ButtonTag>
		);
	}
}

SpanButton.propTypes = {
	color: PropTypes.any,
	className: PropTypes.any,
	onClick: PropTypes.any,
};